import { fromJS } from 'immutable'

import { BANNERS } from '../micrositeAndElsewhereTopBannerConstants'

// Alaska Airlines Group
export const aag = () => {
  return fromJS({
    micrositeAndElsewhereTopBanner: {
      banners: [BANNERS.BENEFITS_EXTENSION],
    },
    micrositeAndElsewhereTopBannerProps: {
      extensionCustomerDisplayName: 'Hawaiian Airlines',
    },
  })
}
